var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3048 3.81014C14.2313 3.19711 13.6536 2.60928 13.0492 2.53053C9.36326 2.07255 5.63603 2.07255 1.95132 2.53053C1.34636 2.60911 0.768649 3.19711 0.695161 3.81014C0.434946 6.05685 0.434946 8.23526 0.695161 10.4815C0.768649 11.0945 1.34636 11.6829 1.95132 11.7611C5.63603 12.219 9.3634 12.219 13.0492 11.7611C13.6536 11.683 14.2313 11.0945 14.3048 10.4815C14.5651 8.23547 14.5651 6.05685 14.3048 3.81014ZM6.33324 9.47956V4.81275L9.83331 7.14624L6.33324 9.47956Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7e0f3d9c72f76af753e50c129f288d39.svg";
export { ForwardRef as ReactComponent };